import * as React from 'react';

import type {CoreEntityType, EntityListViewType} from 'nutshell-core/types';

import {LocationPinRegularIcon as MapIcon} from 'shells/icon/svg/location-pin-regular-icon';
import {ViewBoardIcon as BoardIcon} from 'shells/icon/svg/view-board-icon';
import {ViewExploreIcon as ExploreIcon} from 'shells/icon/svg/view-explore-icon';
import {ViewListIcon as ListIcon} from 'shells/icon/svg/view-list-icon';
import {IconTabs} from 'shells/tabs/icon-tabs/icon-tabs';
import {LEAD_BOARD_TOUR_VIEW_SWITCHER_ID} from 'shells/tours/tours';

import styles from './entity-list-view-selector.module.css';

type Props = {
    currentView: EntityListViewType;
    entityType: CoreEntityType;
    onChange: (arg1: string) => any;
};

export function EntityListViewSelector(props: Props) {
    const BOARD = {
        Icon: BoardIcon,
        label: 'Board',
        isActive: props.currentView === 'board',
        id: 'board',
        onClick: () => props.onChange('board'),
    } as const;
    const LIST = {
        Icon: ListIcon,
        label: 'List',
        isActive: props.currentView === 'list',
        id: 'list',
        onClick: () => props.onChange('list'),
    } as const;
    const MAP = {
        Icon: MapIcon,
        label: 'Map',
        isActive: props.currentView === 'map',
        id: 'map',
        onClick: () => props.onChange('map'),
    } as const;
    const CHART = {
        Icon: ExploreIcon,
        label: 'Chart',
        isActive: props.currentView === 'explore',
        id: 'explore',
        onClick: () => props.onChange('explore'),
    } as const;

    const VIEWS = {
        leads: [BOARD, LIST, MAP, CHART],
        accounts: [LIST, MAP],
        contacts: [LIST, MAP],
    } as const;

    return (
        <div id={LEAD_BOARD_TOUR_VIEW_SWITCHER_ID} className={styles.container}>
            {/* @ts-expect-error */}
            <IconTabs tabs={VIEWS[props.entityType]} />
        </div>
    );
}
